import React, { ReactChild, FC } from "react";
import styled from "styled-components";

interface ICountConfigurationContainer {
  children: ReactChild;
  label?: string;
  className?: string;
}

const CountConfigurationContainer: FC<ICountConfigurationContainer> = ({
  children,
  label = "Добавить",
  className,
}) => {
  return (
    <Wrapper className={className}>
      <Head>{label}</Head>
      <Inner>{children}</Inner>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Head = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`;

const Inner = styled.ul`
  padding: 0;
  column-count: 2;
  margin: 0 -20px 0 0;

  @media (max-width: 850px) {
    column-count: 1;
  }
`;

export default CountConfigurationContainer;
